/* eslint-disable prettier/prettier */
/**
 *
 * Asynchronously loads the component for Login
 *
 */

import loadable from 'utils/loadable';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "Login" */
      /* webpackPreload: true */ './index'
    ), { isPageLoad: true },
);
